/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Protein_Meals_TwoInputs */

const en_us2_protein_meals_two = /** @type {(inputs: Protein_Meals_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2`)
};

const pt_br2_protein_meals_two = /** @type {(inputs: Protein_Meals_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas`)
};

const es_419_protein_meals_two = /** @type {(inputs: Protein_Meals_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2`)
};

const pt_pt2_protein_meals_two = /** @type {(inputs: Protein_Meals_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas`)
};

const fr_fr2_protein_meals_two = /** @type {(inputs: Protein_Meals_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2`)
};

const de_de2_protein_meals_two = /** @type {(inputs: Protein_Meals_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwei`)
};

const it_it2_protein_meals_two = /** @type {(inputs: Protein_Meals_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due`)
};

/**
* | output |
* | --- |
* | "2" |
*
* @param {Protein_Meals_TwoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const protein_meals_two = /** @type {((inputs?: Protein_Meals_TwoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Protein_Meals_TwoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_protein_meals_two(inputs)
	if (locale === "es-419") return es_419_protein_meals_two(inputs)
	if (locale === "pt-PT") return pt_pt2_protein_meals_two(inputs)
	if (locale === "fr-FR") return fr_fr2_protein_meals_two(inputs)
	if (locale === "de-DE") return de_de2_protein_meals_two(inputs)
	if (locale === "it-IT") return it_it2_protein_meals_two(inputs)
	return en_us2_protein_meals_two(inputs)
});
export { protein_meals_two as "protein_meals.two" }